import * as React from 'react';
import Image from '../../../../components/image';

interface ErrorProps {
  children?: React.ReactNode;
}

interface ErrorState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error(error, info);
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    return hasError ? (
      <Image src={`${window.bbGlobal.staticHost}/static/images/misc/pdp/loupe_image_coming_soon.jpg`} />
    ) : (
      children
    );
  }
}

export default ErrorBoundary;
